import { useEffect } from "react";

/**
 * Locks body scroll when `locked` is true.
 * Restores original overflow on unmount or when `locked` becomes false.
 */
export function useLockBodyScroll(locked: boolean) {
  useEffect(() => {
    if (!locked) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, [locked]);
}
